module.exports = __webpack_public_path__ + "img/home-brand-mulino.png?822fb32eb62c805ec84cf57715560474";